import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import EventCell from './EventCell';
import { isSelected } from './utils/selection';
import localizer from './localizer';

const Popup = (props) => {
  const {
    position,
    popupOffset = 5,
    events,
    selected,
    eventComponent,
    slotStart,
    dayHeaderFormat,
    culture,
    ...restProps
  } = props;

  const [state, setState] = useState({
    topOffset: 0,
    leftOffset: 0
  });

  const rootRef = useRef(null);

  useEffect(() => {
    if (rootRef.current && position) {
      const rect = rootRef.current.getBoundingClientRect();
      const viewBottom = window.innerHeight + window.scrollY;
      const viewRight = window.innerWidth + window.scrollX;
      const bottom = rect.top + rect.height + window.scrollY;
      const right = rect.left + rect.width + window.scrollX;

      let topOffset = 0;
      let leftOffset = 0;

      if (bottom > viewBottom) {
        topOffset = bottom - viewBottom + (popupOffset.y || +popupOffset || 0);
      }
      if (right > viewRight) {
        leftOffset = right - viewRight + (popupOffset.x || +popupOffset || 0);
      }

      if (topOffset !== 0 || leftOffset !== 0) {
        setState({ topOffset, leftOffset });
      }
    }
  }, [position, popupOffset]);

  if (!position) return null;

  const { left, width, top } = position;
  const { topOffset, leftOffset } = state;

  const style = {
    top: top - topOffset,
    left: left - leftOffset,
    minWidth: width + (width / 2),
  };

  return (
    <div ref={rootRef} style={style} className="rbc-overlay">
      <div className="rbc-overlay-header">
        {localizer.format(slotStart, dayHeaderFormat, culture)}
      </div>
      {events.map((event, idx) => (
        <EventCell
          key={idx}
          {...restProps}
          event={event}
          component={eventComponent}
          selected={isSelected(event, selected)}
        />
      ))}
    </div>
  );
};

Popup.propTypes = {
  position: PropTypes.object,
  popupOffset: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.shape({
      x: PropTypes.number,
      y: PropTypes.number,
    }),
  ]),
  events: PropTypes.array,
  selected: PropTypes.bool,
  eventComponent: PropTypes.any,
  slotStart: PropTypes.instanceOf(Date),
  dayHeaderFormat: PropTypes.string,
  culture: PropTypes.string,
};

Popup.defaultProps = {
  popupOffset: 5,
};

export default Popup;